// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1XgPa","content":"GlobalSearch_content__2LaM4"};